import config from "../config/env";
import React from "react";
import CareScreener from "../components/care-screener/CareScreener";

const TYPEFORM_ID = config.env.REACT_APP_NEWACCOUNT_TYPE_FORM_ID;
const TYPEFORM_PATH = "newaccount";

export default function NewAccount() {
  return <CareScreener typeformId={TYPEFORM_ID} typeformPath={TYPEFORM_PATH} allowAppointmentScheduling={false} />;
}
